<template>
  <div>
    <v-data-table :headers="headers" :items="roles" :key="reloader" sort-by="RoleId" class="elevation-1">
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-spacer></v-spacer>
          <!-- create role -->
          <v-btn color="primary" dark class="mb-2" @click="createRole()" v-if="canManageAllRoles">Créer un rôle</v-btn>
        </v-toolbar>
      </template>
      <!--Boutons datatable-->
      <template v-slot:[`item.action`]="{ item }" v-if="canManageAllRoles">
        <!-- Edit role -->
        <v-icon class="mr-2" @click="editItem(item)">edit</v-icon>
        <!-- delete role -->
        <v-icon @click="deleteItem(item)">delete</v-icon>
      </template>
    </v-data-table>

    <!-- dialog -->
    <v-dialog v-model="dialog">
      <v-card>
        <v-form ref="roleForm">
          <v-card-title> {{ formTitle }} </v-card-title>
          <v-card-subtitle>
            <v-row>
              <v-col cols="12" sm="12" md="5">
                <!-- role name -->
                <v-text-field id="name" v-model="editedItem.name" label="Nom" :rules="[rules.required, rules.counter]" counter maxlength="60"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="7">
                <!-- role description -->
                <v-text-field
                  id="description"
                  v-model="editedItem.description"
                  label="Description"
                  :rules="[rules.required, rules.counter]"
                  counter
                  maxlength="60"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-subtitle>
          <v-card-text>
            <v-card>
              <v-card-text>
                <v-container fluid class="no-padding-sides">
                  <v-row>
                    <v-col cols="12" xl="6" v-for="permissionGroup in allPermissionsGrouped" :key="permissionGroup.uniqueKey">
                      <!-- permission group title -->
                      <v-row>
                        <v-col cols="12">
                          <h5 class="permission-group-title">{{ permissionGroup.title }}</h5>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" md="6" lg="4" v-for="permission in permissionGroup.values" :key="permission.value" class="col-checkbox">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-checkbox
                                dense
                                hide-details
                                :input-value="doesCurrentRoleHavePermission(allPermissions.find((p) => p.value === permission.value).value)"
                                @change="addRemovePermissionFromRole(allPermissions.find((p) => p.value === permission.value).value, $event)"
                              >
                              <!-- check box label -->
                                <template v-slot:label>
                                  <span v-bind="attrs" v-on="on">{{allPermissions.find((p) => p.value === permission.value).name}}</span>
                                </template></v-checkbox
                              >
                            </template>
                            <span>{{ permission.description }}</span>
                          </v-tooltip>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <!--Boutons dialog-->
            <v-btn color="blue darken-1" text @click="closeDialog()">Annuler</v-btn>
            <v-btn color="blue darken-1" text @click="submitForm(editedItem)">Enregistrer</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vuetify, { VDataTable, VTabs } from "vuetify/lib";
import { getRolesListAsync, createRoleAsync, updateRoleAsync, deleteRoleAsync, getAllPermissionsAsync } from "@/api/accountApi";
import store from "@/store";
import { validate as isValidUUID } from "uuid";
import _ from "lodash";
import PermissionsService from "@/services/PermissionsService";

export default {
  components: {
    VDataTable,
    VTabs,
  },
  data: () => ({
    dialog: false,
    headers: [
      { text: "Id", value: "id", sortable: true },
      { text: "Nom", value: "name", sortable: true },
      { text: "Description", value: "description", sortable: false },
      { text: "Nbr utilisateurs", value: "usersCount", sortable: true },
      { text: "Actions", value: "action", sortable: false },
    ],
    isEditing: false,
    roles: [],
    editedIndex: -1,
    editedItem: {},
    reloader: 0,
    rules: {
      required: (value) => !!value || "Requis.",
      counter: (value) => (value ? value.length <= 60 : "Max 60 caractères"),
    },
    allPermissions: [
      {
        name: "Voir les Utilisateurs",
        value: "users.view",
        groupName: "Permissions sur les Utilisateurs",
        description: "Permission de voir les détails des autres utilisateurs",
      },
      {
        name: "Gérer les Utilisateurs",
        value: "users.manage",
        groupName: "Permissions sur les Utilisateurs",
        description: "Permission de créer, supprimer et modifier les détails des autres utilisateurs",
      },
      {
        name: "Voir les Rôles",
        value: "roles.view",
        groupName: "Permissions sur les Rôles",
        description: "Permission de voir les rôles disponibles",
      },
      {
        name: "Gérer les Rôles",
        value: "roles.manage",
        groupName: "Permissions sur les Rôles",
        description: "Permission de créer, supprimer et modifier les rôles",
      },
      {
        name: "Assigner les Rôles",
        value: "roles.assign",
        groupName: "Permissions sur les Rôles",
        description: "Permission d'assigner les rôles aux utilisateurs",
      },
      {
        name: "Voir les Préférences",
        value: "preferences.view",
        groupName: "Permissions sur les Préférences",
        description: "Permission de voir les Préférences disponibles",
      },
      {
        name: "Gérer les Préférences",
        value: "preferences.manage",
        groupName: "Permissions sur les Préférences",
        description: "Permission de modifier les Préférences",
      },
    ],
    allPermissionsGrouped: [],
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Créer un rôle" : "Modifier un rôle";
    },
    canViewAllRoles(){
      return PermissionsService.RolesPermissionsService.canViewAllRoles;
    },
    canManageAllRoles(){
      let permission = PermissionsService.RolesPermissionsService.canManageAllRoles;
      // If we don't have the permission to manage roles, we wanna remove the actions header from the datatable
      if(!permission && this.headers.find(h => h.text == "Actions")){
        this.headers = this.headers.filter(h => h.text != "Actions");
      }
      
      return permission;
    },
  },

  watch: {
    dialog(val) {
      val || this.closeDialog();
    },
  },

  async mounted() {
    // Check if the user can see this page
    if(!this.canViewAllRoles){
      store.dispatch("setSnackbar", {
        title: `Non Autorisé`,
        text: `Vous n'êtes pas autorisé à consulter cette ressource.`,
        status: "warning",
        timeout: 2000,
      });

      this.$router.replace("/");
    }

    // Get all the permissions from the rest api, group them by grouName
    await this.getAllPermissionsAndGroupThem();

    await this.initializeList();
  },

  methods: {
    // Init the list of roles
    async initializeList() {
      this.roles = await getRolesListAsync();
    },

    // CREATE or UPDATE the role with form validation
    async submitForm(role) {
      // Validate the form
      var isFormValid = this.$refs.roleForm.validate();

      // If the form is valid
      if (isFormValid) {
        var result = !this.isEditing ? await createRoleAsync(role) : await updateRoleAsync(role.id, role);

        // If we have an id > 0 in the result, the save succeeded
        if (result && (isValidUUID(result.id) || result.id > 0)) {
          var createdOrUpdatedMessage = !this.isEditing ? "créée" : "mise à jour";

          store.dispatch("setSnackbar", {
            title: `Rôle ${createdOrUpdatedMessage}`,
            text: `Le rôle a bien été ${createdOrUpdatedMessage}.`,
            status: "success",
            timeout: 2000,
          });

          this.editedItem = {};
          this.editedItem.permissions = [];
          this.$refs.roleForm.reset();
          this.isEditing = false;
        }

        this.closeDialog();

        await this.initializeList();
      }
      // Else display the error messages
      else {
        // Handle missing name
        if (!role.name) {
          store.dispatch("setSnackbar", {
            title: "Nom requis",
            text: "Veuillez renseigner le nom.",
            status: "error",
            timeout: 2000,
          });
        }

        // Handle missing description
        if (!role.name) {
          store.dispatch("setSnackbar", {
            title: "Description requise",
            text: "Veuillez renseigner la description.",
            status: "error",
            timeout: 2000,
          });
        }
      }
    },

    // DELETE a role
    async deleteItem(item) {
      if (confirm("Etes-vous sûr de vouloir supprimer ce rôle ?")) {
        var result = await deleteRoleAsync(item.id);

        // If the result is the id of the exercise the deletion worked
        if (result && item.id === result.id) {
          // Refresh the exercice page with the provided parameters
          await this.initializeList();

          store.dispatch("setSnackbar", {
            title: "Rôle supprimé",
            text: "Le rôle a bien été supprimé.",
            status: "success",
            timeout: 2000,
          });
        }
      }
    },

    // Check if the current role have the specified permission
    doesCurrentRoleHavePermission(permissionToCheck) {
      if (this.editedItem && this.editedItem.permissions) {
        const result = this.editedItem.permissions.find((permission) => permission.value === permissionToCheck);

        return result ? true : false;
      }

      return false;
    },

    // Add or remove a permission from a role
    addRemovePermissionFromRole(permissionValue, isAdding = true) {
      // If we wanna add the permission to the current role
      if (isAdding) {
        const permissionToAdd = this.allPermissions.find((p) => p.value === permissionValue);

        this.editedItem.permissions.push(permissionToAdd);
      }
      // else we wanna delete the permission from current role
      else {
        this.editedItem.permissions = this.editedItem.permissions.filter((p) => p.value !== permissionValue);
      }
    },

    // Open dialog in edition mode
    editItem(item) {
      this.isEditing = true;
      this.editedIndex = this.roles.indexOf(item);
      this.dialog = true;
      this.editedItem = item;
    },

    // Open dialog in creation mode
    createRole() {
      this.editedItem = {};
      this.editedItem.permissions = [];
      this.dialog = true;
    },

    // Close the dialog
    closeDialog() {
      this.dialog = false;
    },

    // Get all the permissions from the rest api, group them by grouName
    async getAllPermissionsAndGroupThem() {
      let allPermissions = await getAllPermissionsAsync();
      if (allPermissions && allPermissions.length) {
        this.allPermissions = allPermissions;

        let uniqueKey = 0;

        this.allPermissionsGrouped = _.chain(allPermissions)
          // Group by groupName to iterate on it
          .groupBy("groupName")
          // Add a key for the foreach and a title property
          .map((value, key) => ({ title: key, uniqueKey: uniqueKey++, values: value }))
          .value();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.permission-group-title {
  margin: 0px;
  padding-bottom: 5px;
  padding-top: 10px;
  font-weight: 500;
  font-size: 16px;
}
.col-checkbox {
  padding-top: 0;
  padding-bottom: 0;
}
::v-deep label {
  margin-bottom: 0;
  font-size: 14px;
}
::v-deep .v-dialog:not(.v-dialog--fullscreen) {
  max-height: 100%;
}
</style>
